export const getLevelNumber = (level: string) => {
  if (level.includes('2')) {
    return 2
  }

  if (level.includes('3')) {
    return 3
  }

  if (level.includes('4')) {
    return 4
  }
  return 1
}
